import React, {useEffect, useRef, useState} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import {getPriceDisplay, priceChangeMessage} from '../pricing-request/price-display';

/** One polite status for every price on the page, so a change is announced once. */
const PriceLiveStatus = observer(() => {
    const previous = useRef<string | null>(null);
    const [message, setMessage] = useState('');
    const {show_pricing, price, price_discount, price_resolved} = s.ui;

    useEffect(() => {
        const result = priceChangeMessage(previous.current, show_pricing ? getPriceDisplay({price, price_discount, price_resolved}) : null);
        previous.current = result.previous;
        if (result.message) setMessage(result.message);
    }, [show_pricing, price, price_discount, price_resolved]);

    return (
        <div
            className="price-live-status"
            role="status"
            aria-live="polite"
            aria-atomic="true"
        >
            {message}
        </div>
    );
});

export default PriceLiveStatus;
